import { ref } from "vue";

export default async function useFetch(url, date) {
  const data = ref(null);
  const response = ref(null);
  const error = ref(null);
  const loading = ref(null);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var route = { route: url, beginDate: date.start, endDate: date.end };

  const post = async () => {
    loading.value = true;
    try {
      const result = await fetch("api/reports", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(route),
      })
        .then((r) => r.json())
        .then((json) => {
          if (!json.isSuccess) {
            error.value = "serverConnectionError";
            throw '';
          }
          return json.result;
        });
      response.value = result;
      data.value = result;

    } catch (ex) {
      error.value = "serverConnectionError";
    } finally {
      loading.value = false;
    }

  }
  //!confing.skip && 
  post()
  return { response, error, data, loading, post }
}



